export default ({ $config }) => ({ httpEndpoint: $config.graphQlEndpoint });